export const SearchType = {
  Talmud: process.env.VUE_APP_SEARCH_TYPE === 'Talmud',
  Bible: process.env.VUE_APP_SEARCH_TYPE === 'Bible'
}
